import { render, staticRenderFns } from "./UseAhaSlidesFor.vue?vue&type=template&id=2067c58e&scoped=true&"
import script from "./UseAhaSlidesFor.vue?vue&type=script&lang=js&"
export * from "./UseAhaSlidesFor.vue?vue&type=script&lang=js&"
import style0 from "./UseAhaSlidesFor.vue?vue&type=style&index=0&id=2067c58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067c58e",
  null
  
)

export default component.exports